import React from "react";
import BackIcon from "../../assets/BackIcon";

interface ContainerHeaderProps {
  heading: string;
  headingClassName?: string;
  handleBack?: () => void;
}

const ContainerHeader: React.FC<ContainerHeaderProps> = ({ handleBack, heading, headingClassName = "" }) => {
  return (
    <div className=" flex items-center w-full">
      {handleBack && (
        <div onClick={handleBack} className="cursor-pointer p-0.5 hover:bg-gray-100 rounded-full">
          <BackIcon />
        </div>
      )}
      <div className=" flex items-center w-full justify-center -translate-x-4">
        <h2 className={`${headingClassName}`}>{heading}</h2>
      </div>
    </div>
  );
};

export default ContainerHeader;
